<template>
  <div>
    <footerNavMobile
      v-if="isMobileScreen"
      :pageConfig="pageConfig"
       />
    <footerNavPC
      v-else
      :pageConfig="pageConfig"
       />
  </div>
</template>
<script>
export default {
  name: "ylFooter",
  components: {
    footerNavMobile: () => import("./components/mobile.vue"),
    footerNavPC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      // pageConfig: {},
    };
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
    pageConfig() {
      return this.$store.getters.settings;
    },
  },
  created() {
    // this.settings()
  },
  methods: {
    // async settings() {
    //   const res = await this.$api.settings();
    //   this.pageConfig = res
    // },
  },
};
</script>
<style scoped lang="scss"></style>
